$(function () {
	var $body = $('body, html')
	var $nav = $('.nav')
	var $linkPosition

	initNav()
	initAnimation()
	initData()
	initSmoothScroll($body, $nav, $linkPosition)
})

function initNav() {
	let $window = $(window)
	let $body = $('body, html')
	let $nav = $('.nav')
	let $navSwitch = $('#nav-switch')
	let pageYOffset = 0
	let offset = $('.block-01 .block-title')[0].offsetTop * 2

	$('.nav-menu-link').on('click', function () {
		$navSwitch.prop('checked', false)
		$body.css({ 'overflow-y': 'auto' })
	})

	$window.on('scroll', function () {
		var pageYOffset = $(this)[0].pageYOffset
		var scrollY = $(this)[0].scrollY

		if (scrollY > $nav[0].clientHeight) {
			if (!$nav.hasClass('nav--sticky')) {
				$nav.addClass('nav--sticky')
			}
		} else {
			if ($nav.hasClass('nav--sticky')) {
				$nav.removeClass('nav--sticky')
			}
		}

		if (pageYOffset > $(this)[0].innerHeight) {
			if (pageYOffset > $(this)[0].innerHeight + offset) {
				if ($nav.hasClass('nav--absolute')) {
					$nav.removeClass('nav--absolute')
				}
			} else {
				if (!$nav.hasClass('nav--absolute')) {
					$nav.addClass('nav--absolute')
				}
			}
		} else {
			if ($nav.hasClass('nav--absolute')) {
				$nav.removeClass('nav--absolute')
			}
		}
	})

	$navSwitch.on('change', function () {
		let isChecked = $(this).is(':checked')

		if (isChecked) {
			$body.css({ 'overflow-y': 'hidden' })
		} else {
			$body.css({ 'overflow-y': 'auto' })
		}
	})
}

function initAnimation() {
	$('.step').each(function () {
		$(this).find('.step-01, .step-02, .step-03, .step-04').attr({
			'data-aos': 'fade-down',
		})
	})

	AOS.init({
		duration: 1000,
		once: true,
	})
}

function initData() {
	getData($('#js-readmore'), './data/news-list.csv')
	getData($('#js-bank'), './data/apply-list.csv')
	getData($('#js-fund'), './data/fund-list.json', 'json')
}

function initSmoothScroll($body, $nav, $linkPosition) {
	var $linkPosition

	$('[href^="#"]').each(function () {
		var $link = $(this)

		$link.on('click', function (e) {
			e.preventDefault()
			var $target = $($(this).attr('href'))
			$linkPosition = ($target.length ? $target.offset().top : 0) - $nav.height()

			$body.animate({
				scrollTop: $linkPosition,
			})
		})
	})
}

function getData(target, url, type) {
	type = type || 'text'

	$.ajax({
		url: url,
		type: 'get',
		dataType: type,
	})
		.done(function (data) {
			let result = ''
			if (type === 'text') {
				result = $.csv.toObjects(data)
			} else {
				result = data
			}
			switch (target[0].id) {
				case 'js-readmore':
					insertReadmore(result)
					break
				case 'js-bank':
					insertBank(result)
					break
				case 'js-fund':
					insertFund(result)
					break
				default:
					break
			}
		})
		.fail(function (event) {
			console.log('error', event)
		})
}

function insertReadmore(data) {
	let targetList = $('#js-readmore .readmore-list')
	let ele = ''

	$.each(data, function (index, value) {
		let date = new Date(value.DATE)
		let post = value.POST
		let link = value.LINK

		let processedDate = date.getFullYear() + ' ／ '
		processedDate += date.getMonth() + 1 + ' ／ ' + date.getDate()

		ele += '<li class="readmore-item">'
		ele += '<a class="readmore-link" href="' + link + '" target="_blank">'
		ele += '<div class="readmore-date">' + processedDate + '</div>'
		ele += '<div class="readmore-title">' + post + '</div>'
		ele += '<div class="readmore-cta"><div class="btn btn-primary readmore-btn">了解更多</div></div>'
		ele += '</a></li>'
	})

	targetList.html(ele)
}

function insertBank(data) {
	let targetList = $('#js-bank .bank-list')
	let ele = ''
	let lastline = data.length % 3 || 3

	groupData = data.slice(0, data.length - lastline)
	lastlineData = data.slice(lastline * -1)

	$.each(groupData, function (index, value) {
		let name = value.NAME
		ele += '<li class="bank-item">'
		ele += name + '</li>'
	})

	$.each(lastlineData, function (index, value) {
		let name = value.NAME
		ele += '<li class="bank-item bank-item--lastline">'
		ele += name + '</li>'
	})

	targetList.html(ele)
}

function insertFund(data) {
	let targetList = $('#js-fund')
	let ele = ''

	$.each(data, function (index, value) {
		var eng = value['英文']
		var currency = value['幣別']
		var record = value['配息紀錄'][0]
		var color = index % 2 === 0 ? 'blue' : 'orange'

		ele += '<div class="fund-block fund-bg--' + color + '">'
		ele += '<div class="fund-wrapper">'
		ele += '<table class="fund-table"><thead><tr>'
		ele += '<th colspan="5"><div class="fund-title"><div class="fund-image">'
		ele += '<img class="img-fluid" src="./images/icon/icon-currency-' + eng + '.png">'
		ele += '</div><span>' + currency + '</span></div></th>'
		ele += '</tr></thead>'
		ele += '<tbody>'
		ele += '<tr><th>配息月份</th><td>每單位分配金額</td><td>配息率</td>'
		ele += '<td>年化配息率<span class="small">(%)</span></td>'
		ele += '<td>當期報酬率<span class="small">(%)</span></td></tr>'

		$.each(record, function (recordIndex, recordValue) {
			ele += '<tr><th>' + recordIndex + '</th>'
			ele += '<td>' + recordValue[0] + '</td>'
			ele += '<td>' + recordValue[1] + '</td>'
			ele += '<td>' + recordValue[2] + '</td>'
			ele += '<td>' + recordValue[3] + '</td></tr>'
		})

		ele += '</tbody>'
		ele += '</table>'
		ele += '</div>'
		ele += '</div>'
	})

	targetList.html(ele)
}
